import * as Sentry from "@sentry/react";
import store from "../../../app/store";
import { toast } from "react-toastify";
import axios from "axios";


export const logApiErrorToSentry = (error: any, context: string = "API Error") => {
  const { auth } = store.getState();

  const extra: any = {
    context,
    message: error?.message,
    name: error?.name,
    stack: error?.stack,
  };

  if (error?.config) {
    extra.url = error.config.url;
    extra.method = error.config.method;
    extra.baseURL = error.config.baseURL || error.config?.axiosInstance?.defaults?.baseURL;
    extra.requestData = error.config.data;
    extra.requestHeaders = error.config.headers;
    extra.params = error.config.params;
    extra.timeout = error.config.timeout;
  }

  if (error?.response) {
    extra.status = error.response.status;
    extra.statusText = error.response.statusText;
    extra.responseData = error.response.data;
    extra.responseHeaders = error.response.headers;
  }

  extra.user = {
    email: auth?.userEmail,
    role: auth?.userRole,
    vendorKey: auth?.currentUser?.vendor_key,
    ...auth
  };

  console.log("extra error ", extra)

  Sentry.captureException(error, {
    level: "error",
    tags: { type: "API Error" },
    extra,
  });
};

export function formatNumber(number: any) {
  if (number === null || number === undefined || number === "") return "";
  const cleanValue = String(number).replace(/,/g, "");
  const num = Number(cleanValue);
  if (isNaN(num)) return "";
  return new Intl.NumberFormat("en-IN").format(num);
}

export const parseNullableNumber = (value: string): number | null => {
  return value.trim() === "" ? null : Number(value);
};

export const lastTwoDecimal = (number: number) => {
  return Math.floor(number * 100) / 100;
};

export const removeKeys = (obj: any, keysToRemove: string[]) => {
  const clone = { ...obj };
  keysToRemove.forEach((key) => {
    delete clone[key];
  });
  return clone;
}

export const copyToClipboard = (text: string, successMsg: string, failureMsg: string) => {
  navigator.clipboard.writeText(text)
    .then(() => {
      toast.success(successMsg);
    })
    .catch(() => {
      toast.error(failureMsg);
    });
};

export const purposeValEnhancer = (str: any) => {
  const blacklistWords = ['or']; // Add more if needed

  return str
    ?.trim()
    ?.replace(/[^a-zA-Z0-9]+/g, '-')       // Replace non-alphanumerics with hyphen
    ?.replace(/^-+|-+$/g, '')              // Trim leading/trailing hyphens
    ?.replace(/-{2,}/g, '-')               // Collapse multiple hyphens
    ?.split('-')
    ?.filter((word: string) => !blacklistWords.includes(word.toLowerCase())) // Remove 'or', 'and', etc.
    ?.map((word: string) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize
    ?.join('-');
};

export const truncatedText = (originalText: string) => {
  const maxLength = 10;
  return originalText.slice(0, maxLength) + "..." + originalText.slice(-7);
};

export const getCurrentIP = async () => {
  try {
    const res = await axios.get("https://geolocation-db.com/json/");
    return res.data?.IPv4 ?? "";
  } catch (e) {
    logApiErrorToSentry(e, "getCurrentIP");
    return null; 
  }
};

export const kycDocsId = {
  E_VERIFY_VOTERID: 8,
  VERIFY_VOTERID_DOC: 12,
  E_VERIFY_DL: 5,
  VERIFY_DL_DOC: 10,
  E_VERIFY_PAN: 1,
  VERIFY_AADHAR_CARD: 2,
  UPLOAD_AADHAR_BACK: 16,
  PASSPORT_FRONT: 3,
  PASSPORT_BACK: 4,
};